import { IActionContext } from '@msdyn365-commerce/core';
import React, { useEffect } from 'react';
import { getProductPromotionsAsync } from '../../../../actions/DataActionExtension.g';
import { IProductPromotion } from '../../../../actions/DataServiceEntities.g';

const ProductPromotions = ({
    recordId,
    variantId,
    actionContext,
    sitePath
}: {
    recordId?: number;
    variantId?: number;
    actionContext: IActionContext;
    sitePath: string;
}) => {
    const [productPromo, setProductPromo] = React.useState<IProductPromotion[]>([]);
    useEffect(() => {
        if (recordId) {
            (async () => {
                var productPromotionsInput = await getProductPromotionsAsync({ callerContext: actionContext }, recordId, variantId ?? 0);

                if (productPromotionsInput) {
                    setProductPromo(productPromotionsInput);
                }
            })();
        }
    }, [recordId ?? 0, variantId ?? 0]);

    var offers = productPromo?.filter(o => o.OfferId);
    if (offers && offers.length > 0) {
        return (
            <ul className='hei-buybox-promotion-list'>
                {offers.map(o => {
                    return (
                        <li key={o.OfferId} className='hei-buybox-promotion-item' data-offer={o.OfferId}>
                            <a href={`${sitePath}/promotion/${o.OfferId?.toLowerCase()}`}>{o.Name}</a>
                        </li>
                    );
                })}
            </ul>
        );
    }

    return null;
};

export { ProductPromotions };
